import axios from 'axios'
import { CONSTANTS, URLS } from '../factories'
import { AuthModule } from '../store'

export default {
  submit (message: string, stackTrace: string) {
    const tokenString = 'Bearer ' + AuthModule.token!.authenticationToken
    const headersObj = { Authorization: tokenString }

    const errorApiUrl = AuthModule.isProduction ? URLS.production.errorApiUrl : URLS.replica.errorApiUrl

    const exception = {
      message: message,
      stackTrace: stackTrace
    }

    return axios({
      method: 'POST',
      url: errorApiUrl + '/errors/' + CONSTANTS.clientId,
      headers: headersObj,
      data: exception
    })
  }
}
